exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".b-avatar[data-v-1dba792b]{width:42px;height:42px;margin-top:16px}.card.message-item-card[data-v-1dba792b]{border:none}.card.message-item-card .card-body[data-v-1dba792b]{padding:8px}.video-js[data-v-1dba792b]{width:640px;height:268px}@media (max-width:768px){.video-js[data-v-1dba792b]{width:calc(100vw - 95px)}}", ""]);

// exports
